import React, { createContext, useContext } from 'react'
import { useChatGateway } from '../hooks/useChatGateway'
import { useChatMessages } from '../hooks/useChatMessages'
import { useChatMode } from '../hooks/useChatMode'

const ChatGatewayContext = createContext<ReturnType<
  typeof useChatGateway
> | null>(null)
const ChatMessagesContext = createContext<ReturnType<
  typeof useChatMessages
> | null>(null)
const ChatModeContext = createContext<ReturnType<typeof useChatMode> | null>(
  null,
)

const ChatGatewayProvider = ({ children }: { children: React.ReactNode }) => {
  const gateway = useChatGateway()

  return (
    <ChatGatewayContext.Provider value={gateway}>
      {children}
    </ChatGatewayContext.Provider>
  )
}

export const ChatProvider = ({ children }: { children: React.ReactNode }) => {
  const messages = useChatMessages()
  const chatMode = useChatMode()

  return (
    <ChatMessagesContext.Provider value={messages}>
      <ChatModeContext.Provider value={chatMode}>
        <ChatGatewayProvider>{children}</ChatGatewayProvider>
      </ChatModeContext.Provider>
    </ChatMessagesContext.Provider>
  )
}

export const useChatGatewayContext = () => {
  const context = useContext(ChatGatewayContext)
  if (!context)
    throw new Error('useChatGatewayContext must be used within ChatProvider')
  return context
}

export const useChatMessagesContext = () => {
  const context = useContext(ChatMessagesContext)
  if (!context)
    throw new Error('useChatMessagesContext must be used within ChatProvider')
  return context
}

export const useChatModeContext = () => {
  const context = useContext(ChatModeContext)
  if (!context)
    throw new Error('useChatModeContext must be used within ChatProvider')
  return context
}
